import React from 'react'

const PatientRegistration = () => {
  return (
    <div className='mx-auto p-4'>
      PatientRegistration
    </div>
  )
}

export default PatientRegistration
